import React from "react";
import { getStockStatusMeta } from "../../features/search/stockStatus";

export const StockStatusTag = ({ result }) => {
  const meta = getStockStatusMeta(result.StockStatus);

  return (
    <p className="stock-tag" style={{ background: meta.color }}>
      {meta.label}
    </p>
  );
};
